"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PushCountResponseSchema = void 0;
var zod_1 = require("zod");
exports.PushCountResponseSchema = zod_1.z.object({
    count: zod_1.z.number(),
});
